module.exports = __webpack_public_path__ + "static/01-886c0050358f163d6292c97801559db9.png";